/**
 * The clinician's own calendar date as YYYY-MM-DD, in the browser's local time.
 *
 * The backend runs on UTC, so after 8 pm Eastern its `date.today()` is already
 * tomorrow — and every note generated in the evening was dated the next day.
 * Requests that ask an engine to write "today" send this instead.
 */
export function localToday(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
